import React, { useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { ACTION_BUTTON_IDS, useActionButtonCommonErrors } from '../utils.ts';
import { CITY_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { useMechanicValidatorCity } from '../../../store/selectors/useMechanicValidatorCity.ts';
import { HiddenUIElement } from '@colonist/game-beginner-mode';
import clsx from 'clsx';
import styles from '../UIGameActionButtonContainer.module.scss';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
const cardsToBuildCity = getCardsForPiece(PieceTypes.City);
export const UIGameActionButtonCity = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const { getPlayerValidator } = usePlayerValidators();
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const tooltipRef = useRef(null);
    const playerValidator = getPlayerValidator(myColor);
    const { sendBuildCity, sendCancelAction, sendClearCornerHighlight } = useGameStore((state)=>state.gameSendEvent);
    const beginnerActionState = useGameStore((state)=>state.gameBeginnerHint.beginnerActionState);
    const currentStateValidator = useCurrentStateValidator();
    const cityValidator = useMechanicValidatorCity();
    const actionStatus = useMemo(()=>{
        if (!cityValidator) {
            return {
                canTakeAction: false
            };
        }
        const canPlaceCityActionStatus = cityValidator.canPlayerPlaceCity(myColor);
        return canPlaceCityActionStatus;
    }, [
        cityValidator,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuildCity);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const icon = CITY_IMAGE_PATH[myColor];
    const isHidden = beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.hiddenUIElements.includes(HiddenUIElement.CityActionButton);
    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isHidden;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingCity = actionState === ActionState.PlaceCity && !disabled;
    var _cityValidator_getCityPlayerState_bankCityAmount;
    const bankCityAmount = (_cityValidator_getCityPlayerState_bankCityAmount = cityValidator === null || cityValidator === void 0 ? void 0 : cityValidator.getCityPlayerState(myColor).bankCityAmount) !== null && _cityValidator_getCityPlayerState_bankCityAmount !== void 0 ? _cityValidator_getCityPlayerState_bankCityAmount : 0;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingCity) {
            sendClearCornerHighlight();
            sendCancelAction();
        } else {
            sendBuildCity();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: clsx(className, {
            [styles.hidden]: isHidden
        }),
        id: ACTION_BUTTON_IDS.buildCity,
        count: bankCityAmount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingCity,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardsToBuildCity,
            ref: tooltipRef
        }),
        onClick: onClick
    });
};
